/*
 * @Author:
 * @LastEditTime: 2022-06-15 15:56:10
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinSystem = {
  async apiSystemParams(arg = { method: '', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'getSystem':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/std/SystemSetting/system-parameter-list?${qs.stringify(arg.params)}`
          )
        )
        break
      case 'addSystemParams':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/SystemSetting/system_params_async', arg.params)
        )
        break
      case 'updateSystemParams':
        ;[err, res] = await To(
          wizStandardInstance.patch('/api/std/CodeRule/system-parameter', arg.params)
        )
        break
      case 'getDictionaryClassList':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/DicCate/getlistpagebyconditionasync/${arg.params.pageNo}/${arg.params.pageSize}/${arg.params.sortName}/${arg.params.sortType}/${arg.params.keywords}/${arg.params.flag}`
            )
          )
        )
        break
      case 'uploadFile':
        ;[err, res] = await To(wizStandardInstance.post('/file/upload_files', arg.formData))
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinSystem,
}
